(function() {
    'use strict';

    angular
        .module('claimsApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider', '$urlRouterProvider','GLOBAL_URL'];
    function stateConfig($stateProvider, $urlRouterProvider,GLOBAL_URL) {
    	$urlRouterProvider.otherwise("/claim-registration");
    	
    	$stateProvider.state('claim-registration', {
    		  url: '/claim-registration',
    		  data: {
              	pageTitle: 'Đăng ký giải quyết quyền lợi bảo hiểm'
              },
              views: {
              	'content@': {
                      templateUrl: GLOBAL_URL +'partial?uri=ga/locked/locked',
                      // templateUrl: GLOBAL_URL +'partial?uri=ga/claims/registration/claim-registration',
                      // controller: 'ClaimRegistrationController as claimRegistrationCtr'
                   }
              }
    	});
    	
    	$stateProvider.state('claim-registration-gam', {
  		  	url: '/claim-registration-gam/:txnId/:taskId',
  		  	data: {
            	pageTitle: 'Sửa lỗi đăng ký giải quyết quyền lợi bảo hiểm'
            },
	        params: { txnId: {squash: true, value: null }, taskId: {squash: true, value: null }},
	        views: {
	        	'content@': {
	                templateUrl: GLOBAL_URL +'partial?uri=ga/claims/registration/claim-registration-gam',  
	                controller: 'ClaimRegistrationGamController as claimRegistrationGamCtr'
	             }
	        }
    	});
    	
    	$stateProvider.state('claim-registration-history', {
    		  url: '/claim-registration-history/:txnId',
    		  data: {
              	pageTitle: 'Lịch sử đăng ký giải quyết quyền lợi bảo hiểm'
              },
              params: { 
            	  txnId: {squash: true, value: null }
              },
              views: {
              	'content@': {
                      templateUrl: GLOBAL_URL +'partial?uri=ga/claims/registration/claim-registration-history',  
                      controller: 'ClaimRegistrationHistoryController as claimRegistrationHistoryCtr'
                   }
              }
    	});
    	
    	$stateProvider.state('claim-adjust-info', {
  		  	url: '/claim-adjust-info?claimNum',
  		  	data: {
            	pageTitle: 'Bổ sung thông tin quyền lợi bảo hiểm'
            },
            params: {
	            claimNum: null
	        },
	        views: {
	        	'content@': {
	                templateUrl: GLOBAL_URL +'partial?uri=ga/claims/adjust-info/claim-adjust-info',  
	                controller: 'ClaimAdjustInfoController as claimAdjustInfoCtr'
	             }
	        }
    	});
    	$stateProvider.state('claim-adjust-info-gam', {
  		  	url: '/claim-adjust-info-gam/:txnId/:taskId',
  		  	data: {
            	pageTitle: 'Sửa lỗi Bổ sung thông tin quyền lợi bảo hiểm'
            },
            params: { txnId: {squash: true, value: null }, taskId: {squash: true, value: null }},
	        views: {
	        	'content@': {
	                templateUrl: GLOBAL_URL +'partial?uri=ga/claims/adjust-info/claim-adjust-info-gam',  
	                controller: 'ClaimAdjustInfoGamController as claimAdjustInfoGamCtr'
	             }
	        }
    	});
    	
    	$stateProvider.state('claim-adjust-info-history', {
  		  	url: '/claim-adjust-info-history/:txnId',
  		  	data: {
            	pageTitle: 'Lịch sử Bổ sung thông tin quyền lợi bảo hiểm'
            },
            params: { txnId: {squash: true, value: null }},
	        views: {
	        	'content@': {
	                templateUrl: GLOBAL_URL +'partial?uri=ga/claims/adjust-info/claim-adjust-info-history',  
	                controller: 'ClaimAdjustInfoHistoryController as claimAdjustInfoHistoryCtr'
	             }
	        }
    	});
    	
    	
    }
})();
